@if ({ value: desktop$ | async }; as isDesktop) {
  @if (currentMeet$ | async; as currentMeet) {
    <app-page-title
      [title]="currentMeet.longName"
      [subtitle]="currentMeet.meetDates | meetDate: currentMeet.timeFormat : currentMeet.dateString"
      [desktopOverrideTitle]="overrideTitle"
      [desktopOverrideSubtitle]="null"
    ></app-page-title>
    <div class="meet-content--main-column">
      <app-meet-banner-ad></app-meet-banner-ad>
      @if (currentMeet.logo && !isDesktop.value) {
        <div class="meet-logo mb-3">
          <img
            class="meet-logo--img"
            fetchpriority="high"
            src="https://alivestatic.athletic.net/meet-images/{{ currentMeet.logo }}"
          />
        </div>
      }
      @if (currentMeet.noteMsg) {
        <div class="alert alert-info">
          <strong>{{ currentMeet.noteSubject }}</strong> {{ currentMeet.noteMsg }}
        </div>
      }
      <div ngbAccordion [destroyOnHide]="false">
        @if (liveRunEvents$ | async; as liveRunEvents) {
          @if (liveFieldEvents$ | async; as liveFieldEvents) {
            @if ((liveRunEvents && liveRunEvents.length > 0) || (liveFieldEvents && liveFieldEvents.length > 0)) {
              <div ngbAccordionItem="live" #live="ngbAccordionItem" [collapsed]="false">
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="justify-content-between">
                    <span>
                      <fa-icon [icon]="environment.icons.live" [fixedWidth]="true" class="me-2"></fa-icon>
                      <span i18n="Live Now Title on the home dashboard@@dashboard.liveNow">Live Now</span>
                    </span>
                    <fa-icon [icon]="live.collapsed ? ['far', 'chevron-down'] : ['far', 'chevron-up']"></fa-icon>
                  </button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <app-live-event-list [showTitle]="false"></app-live-event-list>
                    </ng-template>
                  </div>
                </div>
              </div>
            }
          }
        }
        @if (currentMeet.featureScores && currentMeet.meetScores) {
          <div ngbAccordionItem="scores" #scores="ngbAccordionItem" [collapsed]="false">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton class="justify-content-between">
                <span>
                  <fa-icon [icon]="environment.icons.scores" [fixedWidth]="true" class="me-2"></fa-icon>
                  <span i18n="Team Scores Title on the home dashboard@@dashboard.teamScores">Team Scores</span>
                </span>
                <fa-icon [icon]="scores.collapsed ? ['far', 'chevron-down'] : ['far', 'chevron-up']"></fa-icon>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <app-scores-dashlet [currentMeet]="currentMeet"></app-scores-dashlet>
                </ng-template>
              </div>
            </div>
          </div>
        }
        @if (!isDesktop.value && (currentMeet.athleticNetId || currentMeet.athleticNetMeets)) {
          <div ngbAccordionItem="follow" #follow="ngbAccordionItem" [collapsed]="!followDashletOpen">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton class="justify-content-between" (click)="toggleFollowDashlet()">
                <span>
                  <fa-icon [icon]="environment.icons.followOn" [fixedWidth]="true" class="me-2"></fa-icon>
                  <span i18n="My Follows Title on the home dashboard@@dashboard.myFollows">My Follows</span>
                  @if (followCount > 0) {
                    ({{ followCount }})
                  }
                </span>
                <fa-icon [icon]="follow.collapsed ? ['far', 'chevron-down'] : ['far', 'chevron-up']"></fa-icon>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <app-follow-list></app-follow-list>
                </ng-template>
              </div>
            </div>
          </div>
        }
        <div ngbAccordionItem="events" #events="ngbAccordionItem" [collapsed]="false">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="justify-content-between">
              <span>
                <fa-icon [icon]="environment.icons.events" [fixedWidth]="true" class="me-2"></fa-icon>
                <span i18n="Events Title on the home dashboard@@dashboard.events">Events</span>
              </span>
              <fa-icon [icon]="events.collapsed ? ['far', 'chevron-down'] : ['far', 'chevron-up']"></fa-icon>
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <app-meet-dashboard-event-list></app-meet-dashboard-event-list>
              </ng-template>
            </div>
          </div>
        </div>
        @if (!isDesktop.value && currentMeet.meetLinks && currentMeet.meetLinks.length > 0) {
          <div ngbAccordionItem="meetLinks" #events="ngbAccordionItem" [collapsed]="false">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton class="justify-content-between">
                <span>
                  <fa-icon [icon]="['fas', 'link']" [fixedWidth]="true" class="me-2"></fa-icon>
                  <span>Links</span>
                </span>
                <fa-icon [icon]="events.collapsed ? ['far', 'chevron-down'] : ['far', 'chevron-up']"></fa-icon>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <div class="list-group">
                    @for (meetLink of currentMeet.meetLinks; track meetLink) {
                      <a href="{{ meetLink.url }}" target="_blank" class="list-group-item">
                        <fa-icon class="me-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
                        <span>{{ meetLink.name }}</span>
                      </a>
                    }
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
}
